import axios from 'axios';

class MitConfigService {
  constructor() {
    this.config = null;
    this.features = null;
    this.featureNames = {
      ADMIN_RESET_PASSWORD: 'admin-reset-password',
      ADMIN_EQUIPMENT: 'admin-equipment',
      EQUIPMENT: 'equipment'

    }
  }
  /*
  * fetch - will initialize and load the config from the server
  */
  fetch(){
    return new Promise ((resolve, reject) => {
        axios.get('/clientConfig.json')
          .then((response) => {
            this.config = response.data;
            return resolve(this.config);
          })
          .catch((error) => {
            console.log(error);
            return reject(error);
          });
    });
  }
  /*
  * fetch - will initialize and load the config from the server
  */
  fetchFeatures(){
    return new Promise ((resolve, reject) => {
        axios.get('/api/v1/features')
          .then((response) => {
            this.features = {};
            for(let x = 0; x < response.data.length; x++){
              this.features[response.data[x].name] = response.data[x].enabled;
            }
            return resolve(this.features);
          })
          .catch((error) => {
            console.log(error);
            return reject(error);
          });
    });
  }
  /*
  * get - will get a value from the config
  */
  get(name){
    return this.config[name];
  }
  getFeatureEnabled(name){
    return this.features[name];
  }
}
//This sets this service up like a singlton object.
//Alternatively it could be imported into main.js then referenced from any component by this.$MitConfigService.get()
export default new MitConfigService();
